import { render, staticRenderFns } from "./FormatDetail.vue?vue&type=template&id=6138eea2&scoped=true&"
import script from "./FormatDetail.vue?vue&type=script&lang=js&"
export * from "./FormatDetail.vue?vue&type=script&lang=js&"
import style0 from "./FormatDetail.vue?vue&type=style&index=0&id=6138eea2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6138eea2",
  null
  
)

export default component.exports